import { useBrowseLayoutQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useBrowseLayoutQuery";

export const useIsBrowseLayoutLoading = () => {
  const { isFetching, data } = useBrowseLayoutQuery();
  return isFetching || data === undefined;
};
